import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ThemeSwitcherService {
  constructor(
    @Inject(DOCUMENT) private document:any
  ) {
    this.loadTheme();
  }

  loadTheme(theme: string = environment.theme): void {
    this.insertToDOM(theme);
  }

  insertToDOM = (theme: string) => {
    const documentElement = this.document.documentElement;
    const current = Array.from(documentElement.classList).find((x:any) =>
      x.includes('-theme')
    );
    if (current) {
      documentElement.classList.remove(current);
    }
    documentElement.classList.add(theme);
  };
}
